import { JobListFiltersState, JobListFiltersActionTypes, READ_JOB_LIST_FILTERS_REQUEST, READ_JOB_LIST_FILTERS_SUCCESS, READ_JOB_LIST_FILTERS_FAILURE } from "store/reducers/types/jobList/jobListFilters";

const defaultState: JobListFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function jobsFilters(state = defaultState, action: JobListFiltersActionTypes): JobListFiltersState {
  switch (action.type) {
    case READ_JOB_LIST_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_JOB_LIST_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_JOB_LIST_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};